export default __webpack_public_path__ + "static/media/doc-thumb-icon.0cb52f7c.svg";